import { Stack, Typography } from '@mui/material'
import { MetricTimelineItemReadingTime } from 'features/Metric/components/MetricTimelineItemReadingTime/MetricTimelineItemReadingTime'
import { UIStatusBadge } from 'features/UI'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { routes } from 'routes/routes'
import { ArticleType, ETimelinePostStatus } from 'types'
import { getRoute, isDefined } from 'utils'

export function LibraryArticleItem({
  id,
  title,
  status,
  icon,
  silentReadingTime,
  isPinned,
}: {
  id: number | undefined
  title: string
  icon: string | null
  isPinned: boolean
  status?: ETimelinePostStatus
  silentReadingTime?: number
}) {
  const navigate = useNavigate()

  const handleOpen = () => {
    if (!id) return

    const route = getRoute(
      routes.learnLibraryItem,
      {
        learnLibraryItemType: ArticleType.LearnLibrary,
        learnLibraryItemId: id,
      },
      {
        isPinned: String(isPinned),
      },
    )
    navigate(route)
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        background: 'white',
        padding: 1.5,
        borderRadius: 2,
        width: '100%',
        cursor: 'pointer',
        gap: '8px',
      }}
      onClick={handleOpen}
    >
      {icon && (
        <img
          style={{
            verticalAlign: 'middle',
            maxWidth: 60,
            maxHeight: 60,
          }}
          src={icon}
          width="60px"
          height="60px"
          alt=""
        />
      )}

      <Stack spacing={0} flexGrow={1}>
        <Typography fontWeight={400} fontSize="1.125rem">
          {title}
        </Typography>

        <MetricTimelineItemReadingTime readingTime={silentReadingTime} />
      </Stack>

      {isDefined(status) && <UIStatusBadge status={status} />}
    </Stack>
  )
}
